import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const PublicQuotationPage = () => {
  const { token } = useParams();

  const [html, setHtml] = useState("");
  const [loading, setLoading] = useState(true);
  const [printing, setPrinting] = useState(false);

  useEffect(() => {
    const loadQuotation = async () => {
      try {
        setLoading(true);

        const res = await fetch(`${API_BASE_URL}/public/quotation/${token}`, {
          method: "GET",
        });

        const text = await res.text();

        if (!res.ok) {
          setHtml(`<div style="padding:40px;text-align:center;">
            <h2>Quotation not found</h2>
            <p>This link may be invalid or expired.</p>
          </div>`);
          return;
        }

        setHtml(text);
      } catch (err) {
        setHtml(`<div style="padding:40px;text-align:center;">
          <h2>Failed to load quotation</h2>
          <p>Please try again later.</p>
        </div>`);
      } finally {
        setLoading(false);
      }
    };

    if (token) loadQuotation();
  }, [token]);

  const handlePrint = () => {
    setPrinting(true);

    setTimeout(() => {
      window.print();
      setPrinting(false);
    }, 150);
  };

  if (loading) {
    return <div style={styles.loading}>Loading quotation...</div>;
  }

  return (
    <>
      <style>
        {`
          @media print {
            .public-quotation-action-bar {
              display: none !important;
            }
          }
        `}
      </style>

      <div dangerouslySetInnerHTML={{ __html: html }} />

      <div className="public-quotation-action-bar" style={styles.actionBar}>
        <button
          type="button"
          onClick={handlePrint}
          disabled={printing}
          style={styles.printBtn}
        >
          {printing ? "Opening..." : "Print / Save PDF"}
        </button>
      </div>
    </>
  );
};

const styles = {
  loading: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 14,
    color: "#64748b",
    background: "#fff",
  },
  actionBar: {
    position: "fixed",
    left: "50%",
    bottom: 14,
    transform: "translateX(-50%)",
    width: "min(420px, calc(100% - 24px))",
    background: "rgba(255,255,255,0.96)",
    border: "1px solid #e2e8f0",
    borderRadius: 999,
    padding: 8,
    boxShadow: "0 12px 32px rgba(15,23,42,0.18)",
    zIndex: 9999,
  },
  printBtn: {
    width: "100%",
    border: "none",
    background: "#111827",
    color: "#fff",
    padding: "13px 18px",
    borderRadius: 999,
    fontSize: 14,
    fontWeight: 700,
    cursor: "pointer",
  },
};

export default PublicQuotationPage;